import { ModalComponent, ModalHeader, ModalContent, ModalFooter } from "./dialog.component";
import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";

export * from "./dialog.component";

@NgModule({
    imports: [CommonModule],
    declarations: [
        ModalComponent,
        ModalHeader,
        ModalContent,
        ModalFooter
    ],
    exports: [
        ModalComponent,
        ModalHeader,
        ModalContent,
        ModalFooter
    ]
})
export class ModalModule {

}


// WEBPACK FOOTER //
// ./app/common/dialog/index.ts